import { gearIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from '../../../SvgIcon';

/*
* Kendo Table Tips for Header Card
*/
export const TABLE_TIPS = {
    columnMenu: {
        key: 'columnMenu',
        icon: <SvgIcon icon={gearIcon} />,
        heading: 'Column Menu:',
        children: [
            { key: 'sort', heading: 'Sort', description: ' data by column from the menu.' },
            { key: 'showHide', heading: 'Show or hide', description: ' columns using the column chooser.' }
        ]
    },
    search: { key: 'search', heading: 'Search', description: ' the entire table from the toolbar.' },
    filter: { key: 'filter', heading: 'Filter', description: ' each column.' },
    group: { key: 'group', heading: 'Group', description: ' data by column by dragging headers into the grouping bar.' },
    clear: { key: 'clear', heading: 'Clear Filters', description: ' to reset the table to its original settings.' },
    export: { key: 'export', heading: 'Export', description: ' the table to Excel with included filters and groupings.', isExport: true }
};